//#region import
import React, { useEffect, useState, useCallback } from 'react';
import { Grid, Typography, styled, IconButton, InputAdornment, Button, } from '@mui/material';
import { FnAxios, FnDialog, I18n } from 'utilities/utilities';
import BKImageApplyMember from "assets/images/Parallax/SessionH/BK_ApplyMember.png";
import HideAppBar from '../HomePage/components/HideAppBar';
import { TextBoxItem } from 'components/Input/TextBox';
import { SelectItem } from 'components/Input/Select/SelectItem';
import { APIStatusCode, I18NextNs } from "enum/enum";

import { FormProvider, useForm } from 'react-hook-form';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { ICheckboxItem } from 'components/Input/Checkbox/CheckboxProps';
import { CheckBoxListItem } from 'components/Input/Checkbox/CheckBoxListItem';
import { BtnBack, BtnSave } from 'components/Button/ButtonAll';
import { useNavigate } from 'react-router';
import { ApiApplyMember } from 'enum/api';
import EmailOTP from './EmailOTP';
import NumberInput from 'view/Backend/IncomeExpenses/Ticket/components/NumberInput';
import NumberInputCustom from '../Project/components/NumberInputCustom';
//#endregion

const ContainerBG = styled("div")({
    backgroundImage: `url(${BKImageApplyMember})`,
    backgroundPositionX: "center",
    backgroundPosittionY: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundAttachment: "fixed",
    paddingTop: '5%'
});

const ApplyMember = () => {
    // การสมัครเข้าใช้งานระบบ
    // - ใช้อีเมลเป็น Username
    // - ชื่อสำหรับการเข้าใช้งานระบบจะ Required คือภาษาอังกฤษและตัวเลขเท่านั้น ไม่กำหนดพิมพ์เล็ก/ใหญ่และอักขระพิเศษ
    // - การตั้งค่ารหัสผ่าน ต้องมีอย่างน้อย 8 ตัวอักษรขึ้นไป ประกอบไปด้วย ตัวอักษรพิมพ์เล็ก พิมพ์ใหญ่ สัญลักษณ์พิเศษ โดยไม่ต้องการให้เปลี่ยนรหัสทุก 3 เดือน
    // - (เฉพาะ Account พนักงานกองทุนฯ) มีให้ระบบบังคับเปลี่ยน Password ทุก 90 วัน (หากไม่มีการเปลี่ยน จะไม่สามารถเข้าระบบได้) 
    // - เลือกหน่วยงาน หรือ Create หน่วยงานใหม่ถ้าไม่มีให้เลือก ระบบเก็บเป็น Master > เพื่อแสดงใน Dropdown ให้ / 1 e-mail สามารถอยู่ได้ 1 หน่วยงาน
    // - ยืนยัน OTP ผ่านอีเมล / กรอกภายในระยะเวลาที่กำหนด เป็นวินาที (รอสรุปเวลาที่ Expire) และมีปุ่มขอรหัสผ่านใหม่อีกครั้ง

    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const navigate = useNavigate();
    const [arrOrganizationType, setarrOrganizationType] = useState([]);
    const [arrNameOrganizationAll, setarrNameOrganizationAll] = useState([]);
    const [arrNameOrganization, setarrNameOrganization] = useState([]);
    const [arrUserTitle, setarrUserTitle] = useState([]);    
    const [isNameOrgID, setisNameOrgID] = useState(false);
    const [isConsent, setisConsent] = useState(false);
    const [isIconEye, setisIconEye] = useState(false);
    const [isIconEyeConfirm, setisIconEyeConfirm] = useState(false);

    const form = useForm({
        shouldUnregister: false,
        shouldFocusError: true,
        mode: "all",

        defaultValues: {
            nTitleID: null,
            sFName: null,
            sLName: null,
            nTypeOrgID: null,
            nNameOrgID: null,
            sNameOrg: null,
            sEmail: null,
            sTelNo: null,
            sPWD: null,
            sPWDConfirm: null,            
        } as any,
    });

    useEffect(() => {
        GetFormInitial();
    }, [])

    const GetFormInitial = () => {
        AxiosFn.Get(ApiApplyMember.GetFormInitial, {}, (result) => {
            setarrOrganizationType(result.objResult?.lstOrganizationType);
            setarrNameOrganizationAll(result.objResult?.lstNameOrganization);
            // setarrNameOrganization(result.objResult?.lstNameOrganization);
            setarrUserTitle(result.objResult?.lstUserTitle);           
        })
    }

    const handleClickShowSecuredCode = () => setisIconEye((show) => !show);
    const handleMouseDownSecuredCode = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };

    const handleClickShowSecuredCodeConfirm = () => setisIconEyeConfirm((show) => !show);
    const handleMouseDownSecuredCodeConfirm = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };

    const DefaultDataOption = () => {
        let data: ICheckboxItem[] = [
            { label: `${I18n.SetText("ApplyMember.sConsent")}`, value: "Y" }
        ];
        return data;
    }

    const handleBack = () => navigate("/Home");

    const handleSubmit = (e) => {
        let sPWD = form.getValues("sPWD");
        let sPWDConfirm = form.getValues("sPWDConfirm");
        if (sPWD !== sPWDConfirm) {
            form.setError('sPWDConfirm', { type: 'value', message: `${I18n.SetText("msgChangePasswordConfirm")}` }, { shouldFocus: false, }); //รหัสผ่านไม่ตรงกัน
            return;
        }
        
        let param = {
            sFName: form.getValues("sFName"),
            sLName: form.getValues("sLName"),
            nTypeOrgID: form.getValues("nTypeOrgID"),
            nNameOrgID: form.getValues("nNameOrgID"),
            sNameOrg: form.getValues("sNameOrg"),
            sEmail: form.getValues("sEmail"),
            sTelNo: form.getValues("sTelNo"),
            sSecuredCode: form.getValues("sPWD"),
            nTitleID: form.getValues("nTitleID"),
        };
        DialogFn.Submit(I18n.SetText("Message.ConfirmSaveApplyMember", I18NextNs.labelComponent), () => {
            DialogFn.BlockUI();
            AxiosFn.Post(ApiApplyMember.SaveApplyMember, param, (result) => {
                DialogFn.UnBlockUI();
                if (result.nStatusCode === APIStatusCode.Success) {
                    DialogFn.Success(I18n.SetText("msgOTP"), () => {
                        setObjEmailOTP(result.objResult);
                    });
                    DialogFn.CloseSubmit();
                } else {
                    DialogFn.Warning(result.sMessage);
                    setObjEmailOTP(null);
                }
            }, (err) => {
                DialogFn.UnBlockUI();
                if (!err.response) {
                    DialogFn.Warning(err.sMessage);
                }
            });
        });
    };

    const [ObjEmailOTP, setObjEmailOTP] = useState<any>(null);
    const CallEmailOTP = useCallback(() => {
        return (
            <>
                {ObjEmailOTP && <EmailOTP setisOpen={() => { setObjEmailOTP(null); }} ObjEmailOTP={ObjEmailOTP} />}
            </>
        );
    }, [ObjEmailOTP]);

    const handleChangeOption = (ObjData) => {
        let arrChange = arrNameOrganizationAll.filter(f => f.nParentID === ObjData?.value || f.nParentID === 9999);
        form.setValue('nNameOrgID', null);
        setisNameOrgID(false);
        form.setValue('sNameOrg', null);
        setarrNameOrganization(arrChange);
    }

    return (
        <ContainerBG>
            <HideAppBar />
            <div className="backgournd-content-children-ApplyMember">
                <Grid item className='div-ApplyMember' container xs={12} md={12} spacing={3} justifyContent={"flex-start"}>
                    <FormProvider {...form}>
                        <Grid item container xs={12} md={12} justifyContent={"center"} style={{ paddingBottom: '2%', }}>
                            <Typography variant="h5" display="block" color={"#871414"} >{`${I18n.SetText("ApplyMember.sApplyMember")}`}</Typography>
                        </Grid>
                        <Grid item container xs={12} md={12} spacing={1} style={{ paddingBottom: '1%', }}>
                            <Grid item className='div-breadcrumbs-ApplyMember'>
                                <Typography variant="h6" style={{ fontSize: 'medium', }}>{`${I18n.SetText("ApplyMember.sDataUser")}`}</Typography>
                            </Grid>
                            <Grid item container xs={12} md={12} spacing={2} style={{ padding: '3%' }}>
                                <Grid item xs={12} md={12} container spacing={2}>
                                    <Grid item xs={12} md={6} container spacing={2}>
                                        <Grid item xs={12} md={3}>
                                            <SelectItem
                                                id={"nTitleID"}
                                                name={"nTitleID"}
                                                label={`${I18n.SetText("ApplyMember.nTitleID")}`}
                                                options={arrUserTitle}
                                                required={true}
                                                IsClearable={true}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={9}>
                                            <TextBoxItem
                                                id={"sFName"}
                                                name={"sFName"}
                                                type={'text'}
                                                label={`${I18n.SetText("ApplyMember.sFName")}`}
                                                maxLength={100}
                                                required={true}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextBoxItem
                                            id={"sLName"}
                                            name={"sLName"}
                                            type={'text'}
                                            label={`${I18n.SetText("ApplyMember.sLName")}`}
                                            maxLength={100}
                                            required={true}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} md={12} container spacing={2}>
                                    <Grid item xs={12} md={6}>
                                        <SelectItem
                                            id={"nTypeOrgID"}
                                            name={"nTypeOrgID"}
                                            label={`${I18n.SetText("ApplyMember.nTypeOrgID")}`}
                                            options={arrOrganizationType}
                                            required={true}
                                            IsClearable={true}
                                            onChange={(ObjData) => { handleChangeOption(ObjData); }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <SelectItem
                                            id={"nNameOrgID"}
                                            name={"nNameOrgID"}
                                            label={`${I18n.SetText("ApplyMember.nNameOrgID")}`}
                                            options={arrNameOrganization}
                                            required={true}
                                            IsClearable={true}
                                            onChange={(ObjData) => {
                                                if (ObjData?.value === 9999) {
                                                    setisNameOrgID(true);
                                                } else {
                                                    setisNameOrgID(false);
                                                    form.setValue("sNameOrg", null);
                                                }
                                            }}
                                        />
                                    </Grid>
                                    {isNameOrgID &&
                                        <Grid item xs={12} md={12}>
                                            <TextBoxItem
                                                id={"sNameOrg"}
                                                name={"sNameOrg"}
                                                type={'text'}
                                                label={`${I18n.SetText("ApplyMember.sNameOrg")}`}
                                                maxLength={500}
                                                required={isNameOrgID}
                                            />
                                        </Grid>
                                    }
                                </Grid>
                                <Grid item xs={12} md={12} container spacing={2}>
                                    <Grid item xs={12} md={6}>
                                        <TextBoxItem
                                            id={'sEmail'}
                                            name={'sEmail'}
                                            type={'email'}
                                            label={`${I18n.SetText("ApplyMember.sEmail")}`}
                                            maxLength={150}
                                            required={true}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextBoxItem
                                            id={"sTelNo"}
                                            name={"sTelNo"}
                                            type={'text'}
                                            label={`${I18n.SetText("ApplyMember.sTelNo")}`}
                                            isTelNo={true}
                                            maxLength={10}
                                            required={true}
                                            pattern={'en-number'}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item container xs={12} md={12} spacing={1}>
                            <Grid item className='div-breadcrumbs-ApplyMember'>
                                <Typography variant="h6" style={{ fontSize: 'medium', }} >{`${I18n.SetText("ApplyMember.sDataPassword")}`}</Typography>
                            </Grid>
                            <Grid item container xs={12} md={12} spacing={2} style={{ padding: '3%' }}>
                                <Grid item xs={12} md={6}>
                                    <TextBoxItem
                                        id={"sPWD"}
                                        name="sPWD"
                                        label={`${I18n.SetText("password")}`}
                                        maxLength={20}
                                        required={true}
                                        disabled={false}
                                        type={isIconEye ? "text" : "password"}
                                        isPassword={true} //กรณีเปลี่ยน Type ระหว่าง text กับ password จะต้องมีเช็ค Pattern Password ด้วย ถ้าเป็น text
                                        endAdornment={
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label="toggle password visibility"
                                                    onClick={handleClickShowSecuredCode}
                                                    onMouseDown={handleMouseDownSecuredCode}
                                                    edge="end"
                                                >
                                                    {isIconEye ? <VisibilityOffIcon style={{ color: '#202178' }} /> : <VisibilityIcon style={{ color: '#202178' }} />}
                                                </IconButton>
                                            </InputAdornment>
                                        }
                                        autoComplete="new-password"
                                        IsShowTextCont={false}
                                    />
                                    <Typography variant="body1" style={{ color: '#adadad', fontSize: 'small' }}>{`${I18n.SetText("ApplyMember.msgPassword")}`}</Typography>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextBoxItem
                                        id={"sPWDConfirm"}
                                        name="sPWDConfirm"
                                        label={`${I18n.SetText("confirmpassword")}`}
                                        maxLength={20}
                                        required={true}
                                        disabled={false}
                                        type={isIconEyeConfirm ? "text" : "password"}
                                        isPassword={true} //กรณีเปลี่ยน Type ระหว่าง text กับ password จะต้องมีเช็ค Pattern Password ด้วย ถ้าเป็น text
                                        endAdornment={
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label="toggle password visibility"
                                                    onClick={handleClickShowSecuredCodeConfirm}
                                                    onMouseDown={handleMouseDownSecuredCodeConfirm}
                                                    edge="end"
                                                >
                                                    {isIconEyeConfirm ? <VisibilityOffIcon style={{ color: '#202178' }} /> : <VisibilityIcon style={{ color: '#202178' }} />}
                                                </IconButton>
                                            </InputAdornment>
                                        }
                                        onBlur={(Objvalue) => {
                                            let sPWD = form.getValues("sPWD");
                                            if (sPWD !== Objvalue.target.value) form.setError('sPWDConfirm', { type: 'value', message: `${I18n.SetText("msgChangePasswordConfirm")}` }, { shouldFocus: false, }); //รหัสผ่านไม่ตรงกัน
                                        }}
                                        autoComplete="new-password"
                                        IsShowTextCont={false}
                                    />
                                    <Typography variant="body1" style={{ color: '#adadad', fontSize: 'small' }}>{`${I18n.SetText("ApplyMember.msgPassword")}`}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item container xs={12} md={12} spacing={4} justifyContent={"center"} style={{ paddingBottom: '2%', }}>
                            <Grid item container xs={12} md={12} spacing={1} justifyContent={"center"}>
                                <Grid item>
                                    <CheckBoxListItem
                                        id={'isConsent'}
                                        name={'isConsent'}
                                        required={false}
                                        label={``}
                                        options={DefaultDataOption()}
                                        onChange={(e) => { setisConsent(e.length > 0); }}
                                    />
                                </Grid>
                                <Grid item>
                                    <Button variant="text" style={{ fontSize: '14px'}}><a href={process.env.REACT_APP_FRONTEND_URL + "Privacypolicy?2"} target="_blank" rel="noreferrer" >{`${I18n.SetText("ApplyMember.sPrivacypolicy")}`}</a></Button>
                                    {/* <a style={{ paddingTop: '10px' }} onClick={()=> { navigate("/Privacypolicy?2"); }} target="_blank" rel="noreferrer">{`${I18n.SetText("ApplyMember.sPrivacypolicy")}`}</a> */}
                                </Grid>
                            </Grid>
                            <Grid item container xs={12} md={12} spacing={1} justifyContent={"center"}>
                                <Grid item>
                                    <BtnBack id={"btnBack"} txt={`${I18n.SetText("ApplyMember.msgToHome")}`} onClick={() => handleBack()} />
                                </Grid>
                                <Grid item>
                                    <BtnSave 
                                        id={"btnSave"} 
                                        txt={`${I18n.SetText("ApplyMember.sSave")}`} 
                                        IsDisabled={!isConsent} 
                                        onClick={form.handleSubmit((e) => handleSubmit(e), (err) => console.log("err", err))}
                                     />
                                </Grid>
                            </Grid>
                            {/* <Grid item container xs={12} md={12} spacing={1} justifyContent={"center"}>
                                <Typography variant="body1">{`${I18n.SetText("ApplyMember.msgUser")}`}</Typography>
                                <a style={{ padding: '4px' }} href={"/Home"}>{`${I18n.SetText("ApplyMember.msgLogin")}`}</a>             
                                <Typography variant="body1">{`${I18n.SetText("ApplyMember.msgOR")}`}</Typography>
                                <a style={{ padding: '4px' }} href={"/Home"}>{`${I18n.SetText("ApplyMember.msgToHome")}`}</a> 
                            </Grid> */}
                        </Grid>
                    </FormProvider>
                </Grid>
                <CallEmailOTP />
            </div>
        </ContainerBG>
    )
}
export default ApplyMember;
